<template>
  <div
    class="modal fade p-0"
    id="generateCompanyBalancesheet"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="d-flex flex-wrap w-100 position-relative event-auto">
        <div class="card shadow-none">
          <div
            class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative"
          >
            <div class="content-card-left w-100">
              <h4 class="card-title text-white fs-4">Company BalanceSheet</h4>
              <p class="fw-light text-white mb-0 pt-1">
                Generate PDF for company ledger by date range
              </p>
            </div>
          </div>
          <div class="card-body">
            <Form
              @submit="onSubmit"
              class="custom-form mt-2"
              ref="myForm"
            >
              <div class="position-relative form-group w-100">
                <Multiselect
                  v-model="selectedCompany"
                  :options="companyOptions"
                  class="custom-multiselect"
                  placeholder="Select Company"
                  :searchable="true"
                  :showOptions="true"
                  mode="single"
                  label="name"
                  trackBy="name"
                  valueProp="id"
                />
                <Field
                  type="hidden"
                  name="company_id"
                  v-model="selectedCompany"
                />
                <ErrorMessage
                  class="invalid-message mb-0 pt-2"
                  name="company_id"
                />
              </div>
              <div class="form-group">
                <v-date-picker
                  :popover="{ visibility: 'click' }"
                  class="custom-calendar left-caret-none"
                  popover-align="right"
                  v-model="range"
                  is-range
                  :columns="$screens({ default: 2, lg: 2 })"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <div class="d-flex align-items-center">
                      <div class="position-relative calendar-input-wrapper clearfix w-100">
                        <i
                          class="bi bi-calendar3 position-absolute icon-left-placement icon-without-label"
                        ></i>
                        <input
                          placeholder="From"
                          :value="inputValue.start"
                          v-on="inputEvents.start"
                          class="border-0 icon-left position-relative float-left w-100"
                        />
                      </div>
                      <span class="d-inline-block mx-3 mx-sm-4">To</span>
                      <div class="position-relative calendar-input-wrapper clearfix w-100">
                        <i
                          class="bi bi-calendar3 position-absolute icon-left-placement icon-without-label"
                        ></i>
                        <input
                          placeholder="To"
                          :value="inputValue.end"
                          v-on="inputEvents.end"
                          class="border-0 icon-left position-relative float-left w-100"
                        />
                      </div>
                    </div>
                  </template>
                </v-date-picker>
              </div>
              <div
                class="card-footer custom-pagination d-flex flex-wrap justify-content-between m-0 mb-3 px-4 pb-0 border-0 bg-transparent"
              >
                <button class="btn btn-primary w-100">
                  Generate
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <generate-company-pdf
    :company_id="selectedCompany"
    :company_name="selectedCompanyName"
    :count_number="count_number"
    :start_date="range.start"
    :end_date="range.end"
  ></generate-company-pdf>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import CompanyServices from '@/services/CompanyServices';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';
import GenerateCompanyPdf from '@/components/pdf/GenerateCompanyBalancesheetPdf.vue';

export default {
  components: {
    Multiselect,
    Form,
    Field,
    ErrorMessage,
    GenerateCompanyPdf,
  },
  setup() {
    const companyOptions = ref([]);
    const selectedCompany = ref(0);
    const range = ref({
      start: new Date(),
      end: new Date(),
    });
    const count_number = ref(0);

    const schema = yup.object().shape({
      company_id: yup
        .number()
        .typeError('Company selection required')
        .min(0, 'Company selection required'),
    });

    const selectedCompanyName = computed(() => {
      if (selectedCompany.value === 0 || selectedCompany.value === '0') {
        return 'All Companies';
      }
      if (!selectedCompany.value) {
        return '';
      }
      const match = companyOptions.value.find(
        (company) => company.id === selectedCompany.value
      );
      return match ? match.name : '';
    });


    watch(
      () => selectedCompany.value,
      (value) => {
        if (value === null || value === undefined || value === '') {
          selectedCompany.value = 0;
          return;
        }
        const numeric = Number(value);
        if (!Number.isNaN(numeric) && numeric !== value) {
          selectedCompany.value = numeric;
        }
      }
    );

    const syncCompanyField = () => {
      if (selectedCompany.value === null || selectedCompany.value === undefined || selectedCompany.value === '') {
        selectedCompany.value = 0;
        return;
      }
      const numeric = Number(selectedCompany.value);
      selectedCompany.value = Number.isNaN(numeric) ? 0 : numeric;
    };

    const loadCompanies = async () => {
      await CompanyServices.paginateCompanies().then((response) => {
        const records = response.data.data || [];
        companyOptions.value = [
          { id: 0, name: 'All Companies' },
          ...records,
        ];
      });
    };

    onMounted(() => {
      loadCompanies();
    });

    const onSubmit = () => {
      count_number.value += 1;
    };

    return {
      companyOptions,
      selectedCompany,
      selectedCompanyName,
      range,
      schema,
      onSubmit,
      count_number,
      syncCompanyField,
    };
  },
};
</script>
